import { Button, Header, Modal } from '@bbl-digital/snorre'
import { Text } from '@bbl-digital/snorre-v2'
import { useDispatch } from 'react-redux'
import { InternalLink } from 'shared/components/InternalLink/InternalLink'
import useModal from 'shared/hooks/useModal'
import { SEND_EMAIL_CLOSE } from 'shared/store/sendMessage/email/actionTypes'
import {
  handleRecipientModal,
  onRecipientsClose,
} from 'shared/store/sendMessage/recipients'
import { CustomGrid } from 'shared/styles/common'

type Props = {
  onClose: () => void
  onDecision: (decision: 'yes' | 'no') => void
}

const TransformToBccModal = ({ onClose, onDecision }: Props) => {
  const { close } = useModal()
  const dispatch = useDispatch()
  const handleGoToNotificationClose = () => {
    //Må lukke alle modaler sånn at ingen er åpne lenger når man lander på oppslagssiden
    onClose()
    close()
    dispatch(handleRecipientModal({ open: null, type: null }))
    dispatch(onRecipientsClose())
    dispatch({ type: SEND_EMAIL_CLOSE })
  }
  return (
    <Modal
      open
      onClose={onClose}
      header={<Header level={4}>Legg som blindkopi?</Header>}
      actionButton={
        <CustomGrid cols="1fr 1fr" bp="350px">
          <Button outline type="submit" onClick={() => onDecision('no')}>
            Nei
          </Button>
          <Button type="submit" onClick={() => onDecision('yes')}>
            Ja
          </Button>
        </CustomGrid>
      }
    >
      <Text primary className="mb-2">
        Du har lagt til mange e-postmottakere. Skal adressene skjules for
        mottakerne (blindkopi)?
      </Text>
      <Text primary>
        <strong>Tips</strong>: Hvis du ønsker å dele informasjon med alle
        beboere, kan du heller bruke{' '}
        <InternalLink
          to="/kommunikasjon/oppslag"
          onClick={handleGoToNotificationClose}
          className="inline"
        >
          Oppslag
        </InternalLink>{' '}
        i stedet for e-post.
      </Text>
    </Modal>
  )
}

export default TransformToBccModal
